/** Login/register sonrası geri dönülecek sayfa için sessionStorage anahtarı */
export const AUTH_GATE_REDIRECT_KEY = "auth_gate_redirect";

/** Auth gate üzerinden login'e giderken kullanıcının kaldığı sayfayı sakla */
export const persistAuthGateRedirect = (path: string): void => {
  sessionStorage.setItem(AUTH_GATE_REDIRECT_KEY, path);
};

/** Saklanan redirect path'ini oku ve temizle (tek kullanımlık) */
export const consumeAuthGateRedirect = (): string | null => {
  const path = sessionStorage.getItem(AUTH_GATE_REDIRECT_KEY);
  if (path) {
    sessionStorage.removeItem(AUTH_GATE_REDIRECT_KEY);
  }
  return path;
};

/** Redirect path'ini temizlemeden oku (guard'lardaki fallback için) */
export const readAuthGateRedirect = (): string | null =>
  sessionStorage.getItem(AUTH_GATE_REDIRECT_KEY);

/**
 * Kullanıcının auth akışına girmeden önce gezdiği son sayfa.
 *
 * `persistAuthGateRedirect` yalnızca bilinen giriş noktalarından (header
 * butonları, auth gate popup) çağrılır; kullanıcı sidebar, ürün sayfası
 * veya doğrudan URL ile login'e ulaştığında bu kayıt oluşmaz. Route tracker
 * her navigasyonda auth dışı son sayfayı buraya yazar, login sonrası
 * fallback olarak kullanılır.
 */
export const LAST_VISITED_ROUTE_KEY = "last_visited_route";

/** Bu öneklerle başlayan sayfalar "dönülecek yer" olarak kaydedilmez */
const AUTH_ROUTE_PREFIXES = [
  "/login",
  "/register",
  "/verify-email",
  "/forgot-password",
  "/password-reset-sent",
  "/reset-password",
  "/auth/",
  "/slack-link",
  "/persona-setup",
  "/onboarding",
];

export const isAuthRoute = (pathname: string): boolean =>
  AUTH_ROUTE_PREFIXES.some((prefix) => pathname.startsWith(prefix));

/** Auth dışı her navigasyonda çağrılır — dönüş adresini günceller */
export const trackLastVisitedRoute = (path: string): void => {
  const pathname = path.split("?")[0];
  if (isAuthRoute(pathname)) return;
  sessionStorage.setItem(LAST_VISITED_ROUTE_KEY, path);
};

/** Login sonrası fallback dönüş adresi (auth gate kaydı yoksa) */
export const readLastVisitedRoute = (): string | null =>
  sessionStorage.getItem(LAST_VISITED_ROUTE_KEY);
